import { render, staticRenderFns } from "./_base-gallery.vue?vue&type=template&id=0c24a31a&"
import script from "./_base-gallery.vue?vue&type=script&lang=js&"
export * from "./_base-gallery.vue?vue&type=script&lang=js&"
import style0 from "./_base-gallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports